const Pagination = ({ pagination, page, setPage, limit, setLimit }) => {
  if (!pagination || pagination.totalPages <= 1) return null;

  return (
    <div className="flex flex-col items-center justify-between px-4 py-3 border-t border-slate-100 text-sm text-gray-600 gap-3">

      {/* Left Section */}
      <div className="flex items-center gap-4">
        <p className="whitespace-nowrap">Showing {(page - 1) * limit + 1}–
          {Math.min(page * limit, pagination.total)} of{" "}
          {pagination.total}
          results</p>
      </div>
      <div className="flex items-center justify-between">
        {/* <div className="flex items-center gap-1.5">
          <span className="text-xs text-gray-500">Rows:</span>
          <select
            value={limit}
            onChange={(e) => {
              setLimit(Number(e.target.value));
              setPage(1);
            }}
            className="border border-gray-200 rounded-lg text-xs px-2 py-1.5 bg-slate-50 focus:ring-1 focus:ring-primaryColor/20 focus:border-primaryColor outline-none"
          >
            {[10, 20, 50].map((n) => (
              <option key={n} value={n}>
                {n}
              </option>
            ))}
          </select>
        </div> */}
        {/* Right Section */}
        <div className="flex items-center gap-2">
          {/* Prev */}
          <button
            onClick={() => setPage((p) => p - 1)}
            disabled={!pagination.hasPrevPage}
            className="px-3 py-1.5 border border-gray-200 rounded-lg hover:border-primaryColor hover:text-primaryColor disabled:opacity-40 disabled:cursor-not-allowed transition text-xs font-medium"
          >
            Prev
          </button>

          {/* Page Numbers */}
          {Array.from({ length: pagination.totalPages }, (_, i) => i + 1)
            .filter(
              (p) =>
                p === 1 ||
                p === pagination.totalPages ||
                Math.abs(p - page) <= 1
            )
            .reduce((acc, p, idx, arr) => {
              if (idx > 0 && p - arr[idx - 1] > 1) acc.push("...");
              acc.push(p);
              return acc;
            }, [])
            .map((p, i) =>
              p === "..." ? (
                <span key={`dots-${i}`} className="px-1 text-gray-300">
                  …
                </span>
              ) : (
                <button
                  key={p}
                  onClick={() => setPage(p)}
                  className={`w-8 h-8 rounded-lg text-xs font-semibold transition ${page === p
                    ? "bg-primaryColor text-white shadow-md"
                    : "border border-gray-200 text-gray-600 hover:border-primaryColor hover:text-primaryColor"
                    }`}
                >
                  {p}
                </button>
              )
            )}

          {/* Next */}
          <button
            onClick={() => setPage((p) => p + 1)}
            disabled={!pagination.hasNextPage}
            className="px-3 py-1.5 border border-gray-200 rounded-lg hover:border-primaryColor hover:text-primaryColor disabled:opacity-40 disabled:cursor-not-allowed transition text-xs font-medium"
          >
            Next
          </button>
        </div>
      </div>

    </div>
  );
};

export default Pagination